class WelcomeController {
    /**
     * @param $window
     * @param $location
     * @param $state
     * @param authService
     */
    constructor($window, $location, $state, $mdToast, authService) {
        if(localStorage.getItem('kes_token')) {
            localStorage.removeItem('kes_email');
            localStorage.removeItem('kes_token');
            $window.location.reload();
        }
        this.$location = $location;
        this.$window = $window;
        this.$state = $state;
        this.$mdToast = $mdToast;
        this.authService = authService;
        this.credentials = {};
        this.token = $location.search().token;
        this.valid = null;
        this.loaded = false;
        this.terms = false;
        this.email = '';
    }

    $onInit() {
        this.authService.init(google, 'register', this.token);
        this.authService.checkToken(this.token).then((data) => {
            this.email = data.email;
            this.valid = true;
        }, () => this.valid = false).finally(() => this.loaded = true);
    }

    onRegisterButtonClick() {
        const self = this;
        this.passwordsForm.$submitted = true;
        if(!this.passwordsForm.$invalid && this.credentials.password === this.credentials.repeatPassword) {
            this.authService.loginOrRegister(false, this.credentials, this.token).catch((err) => {
                self.valid = false;
                self.$mdToast.show(
                    self.$mdToast.simple()
                        .textContent(err.data)
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass('error-toast')
                );
            });;
        }
    }

    goToLogin() {
        this.$window.location.href = '/login';
    }
}

WelcomeController.$inject = ['$window', '$location', '$state', '$mdToast', 'AuthService'];

export default WelcomeController;



// WEBPACK FOOTER //
// ./src/app/pages/login/welcome/welcomeController.js